import { createElementIdSlice } from '../utils/action/createElementSlice';
export const JobContentState = createElementIdSlice({
    elementName: 'job-content',
    initialState: {},
    reducers: {
        setJobResultsUri: (state, action) => {
            if (!state) {
                return;
            }
            return Object.assign(Object.assign({}, state), { jobResultsUri: action.payload.data });
        },
        setJobResultsContentSrc: (state, action) => {
            if (!state) {
                return;
            }
            return Object.assign(Object.assign({}, state), { jobResultsContentSrc: action.payload.data });
        },
        setJobResultsContentSrcDoc: (state, action) => {
            if (!state) {
                return;
            }
            return Object.assign(Object.assign({}, state), { jobResultsContentSrcDoc: action.payload.data });
        },
    },
});
